import React from 'react'

// components
import {
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import FormCheckboxInput from './FormCheckboxInput'

const FormCompanyTimeOffType = ({
  id,
  type,
  colSize,
  className,
  inputLabel,
  value,
  handleCheck,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel} :
        </CFormLabel>
      )}
      <FormCheckboxInput
        id={id}
        name={'company_time_off_type_public'}
        className={'mb-2'}
        type={type}
        label='Public / National Holiday'
        handleCheck={handleCheck}
        disabled={disabled}
        value={value === 'public'}
      />
      <FormCheckboxInput
        id={id}
        name={'company_time_off_type_internal'}
        type={type}
        label='Internal / Company Private Time Off'
        handleCheck={handleCheck}
        disabled={disabled}
        value={value === 'internal'}
      />
    </CCol>
  )
}

export default FormCompanyTimeOffType
